import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { FlatpickrModule } from 'angularx-flatpickr';
import { NgbDropdownModule, NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CountUpModule } from 'ngx-countup';

// Load Icons
import { defineElement } from 'lord-icon-element';
import lottie from 'lottie-web';

// Pages Routing
import { PagesRoutingModule } from "./pages-routing.module";
import { LayoutComponent } from './common/layout/layout.component';
import { FooterComponent } from './common/footer/footer.component';
import { HeaderComponent } from './common/header/header.component';
import { TopbarComponent } from './common/topbar/topbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './client/dashboard/dashboard.component';
import { ClientUsersComponent } from './client/client-users/client-users.component';
import { ProjectsModule } from './client/projects/projects.module';
import { PlansComponent } from './management/plans/plans.component';
import { ClientsModule } from './management/clients/clients.module';
import { QuestionnaireTemplatesComponent } from './management/questionnaire-templates/questionnaire-templates.component';
import { CreateQuestionnaireTemplateComponent } from './management/questionnaire-templates/create-questionnaire-template/create-questionnaire-template.component';
import { GeneralListsComponent } from './management/general-lists/general-lists.component';
import { QuestionnaireBaselinesComponent } from './management/questionnaire-baselines/questionnaire-baselines.component';
import { CreateQuestionnaireBaselineComponent } from './management/questionnaire-baselines/create-questionnaire-baseline/create-questionnaire-baseline.component';
import { ApiKeysComponent } from './client/api-keys/api-keys.component';
import { ApiDocsComponent } from './client/api-docs/api-docs.component';
import { ResearchAdminsComponent } from './management/research-admins/research-admins.component';

@NgModule({
  declarations: [
		LayoutComponent,
		FooterComponent,
		HeaderComponent,
		TopbarComponent,
		DashboardComponent,
		ClientUsersComponent,
		PlansComponent,
  	QuestionnaireTemplatesComponent,
   	CreateQuestionnaireTemplateComponent,
    GeneralListsComponent,
    QuestionnaireBaselinesComponent,
    CreateQuestionnaireBaselineComponent,
    ApiKeysComponent,
    ApiDocsComponent,
    ResearchAdminsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
		CountUpModule,
    FlatpickrModule.forRoot(),
    NgbModule,
    SimplebarAngularModule,
    PagesRoutingModule,
		NgxChartsModule,
		ProjectsModule,
		ClientsModule,
		NgbDropdownModule,
		NgbNavModule,
		TranslateModule,
		SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule { 
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
